import { render, staticRenderFns } from "./MentionMenuList.vue?vue&type=template&id=303d501f"
import script from "./MentionMenuList.vue?vue&type=script&lang=js"
export * from "./MentionMenuList.vue?vue&type=script&lang=js"
import style0 from "./MentionMenuList.vue?vue&type=style&index=0&id=303d501f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports